import {
    CREATE_FIELD_FAIL,
    CREATE_FIELD_REQUEST,
    CREATE_FIELD_SUCCESS,
    CREATE_SECTION_FORM_FAIL,
    CREATE_SECTION_FORM_REQUEST,
  CREATE_SECTION_FORM_SUCCESS,
  FETCH_FIELD_FAIL,
  FETCH_FIELD_REQUEST,
  FETCH_FIELD_SUCCESS,
  FETCH_SECTION_FORM_FAIL,
  FETCH_SECTION_FORM_REQUEST,
  FETCH_SECTION_FORM_SUCCESS,
  SHOW_FIELD_FAIL,
  SHOW_FIELD_REQUEST,
  SHOW_FIELD_SUCCESS,
} from "../../ActionType/Section&FieldsTypes/SectionFielsTypes";

export const getSectionFormsReducer = (
  state = { loading: true, sectionForms: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_SECTION_FORM_REQUEST:
      return {
        loading: true,
      };
    case FETCH_SECTION_FORM_SUCCESS:
      return {
        loading: false,
        sectionForms: action.payload,
        error: "",
      };
    case FETCH_SECTION_FORM_FAIL:
      return {
        loading: false,
        sectionForms: action.payload,
        erorr: action.error,
      };
    default:
      return state;
  }
};



export const createSectionFormsReducer = (
    state = { loading: true, sectionForms: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_SECTION_FORM_REQUEST:
        return {
          loading: true,
        };
      case CREATE_SECTION_FORM_SUCCESS:
        return {
          loading: false,
          sectionForms: action.payload,
          error: "",
        };
      case CREATE_SECTION_FORM_FAIL:
        return {
          loading: false,
          sectionForms: action.payload,
          erorr: action.error,
        };
      default:
        return state;
    }
  };


  export const getFieldsReducer = (
    state = { loading: true, fields: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case FETCH_FIELD_REQUEST:
        return {
          loading: true,
        };
      case FETCH_FIELD_SUCCESS:
        return {
          loading: false,
          fields: action.payload,
          error: "",
        };
      case FETCH_FIELD_FAIL:
        return {
          loading: false,
          fields: action.payload,
          erorr: action.error,
        };
      default:
        return state;
    }
  };

  export const showFieldsReducer = (
    state = { loading: true, field: null, error: "" },
    action
  ) => {
    switch (action.type) {
      case SHOW_FIELD_REQUEST:
        return {
          loading: true,
        };
      case SHOW_FIELD_SUCCESS:
        // console.log(action.payload);
        return {
          loading: false,
          field: action.payload,
          error: "",
        };
      case SHOW_FIELD_FAIL:
        return {
          loading: false,
          field: action.payload,
          erorr: action.error,
        };
      default:
        return state;
    }
  };

  export const createFieldReducer = (
    state = { loading: true, fields: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_FIELD_REQUEST:
        return {
          loading: true,
        };
      case CREATE_FIELD_SUCCESS:
        return {
          loading: false,
          fields: action.payload,
          error: "",
        };
      case CREATE_FIELD_FAIL:
        return {
          loading: false,
          fields: action.payload,
          erorr: action.error,
        };
      default:
        return state;
    }
  };